import { initConnection } from "@/api/connection";
import { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const StripeCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (!code) {
      console.error("Missing required OAuth parameters");
      return;
    }

    initConnection({
      provider: "STRIPE",
      code,
    })
      .then(() => {
        navigate("/integrations");
      })
      .catch((error) => {
        console.error("Error processing OAuth callback:", error);
        alert("Failed to connect to Stripe. Please try again.");
      });
  }, [navigate]);
  return (
    <div className="callback-container">
      <h1>Processing OAuth Callback...</h1>
      <p>Please wait while we complete the connection to Stripe.</p>
    </div>
  );
};
